var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89.6,0H38.4C17.2,0,0,17.2,0,38.4v51.2C0,110.8,17.2,128,38.4,128h51.2c21.2,0,38.4-17.2,38.4-38.4V38.4 C128,17.2,110.8,0,89.6,0z M42.6,8.8h42.7v28.1c-3.6,2.2-7.4,5-11,8.9V19.6H53.6l0,26.2c-3.2-3.5-7-6.4-11-8.9V8.8z M48.9,99.8 v19.1h-5v-9.6c0,0,0.6-4.7-4.5-4.7H13.9v-4.5h28.9c1.3,0,1.3-1.9,0-1.9H13.9v-4.4h30.6C49.5,93.8,48.9,96,48.9,99.8z M55.9,87.1 v31.8h-5V96.6c0,0,0.6-4.7-4.5-4.7H13.9v-4.5h36c1.2,0,1.2-1.9,0-1.9h-36v-4.5h37.6C56.5,81.1,55.9,83.2,55.9,87.1z M63,118.9h-5 V83.8c0,0,0.6-4.7-4.5-4.7H13.9v-4.4H57c1.2,0,1.2-1.9,0-1.9H13.9v-4.4h44c3.1,0.6,5,3.7,5,6.9V118.9z M114,98.3H85 c-1.3,0-1.3,1.9,0,1.9H114v4.5H88.5c-5.2,0-4.5,4.7-4.5,4.7v9.6h-5V99.8c0-3.9-0.6-6,4.4-6H114V98.3z M114,85.6h-36 c-1.2,0-1.2,1.9,0,1.9h36v4.5H81.5c-5.2,0-4.5,4.7-4.5,4.7v22.3h-5V87.1c0-3.9-0.6-6,4.4-6H114V85.6z M114,72.8H70.9 c-1.2,0-1.2,1.9,0,1.9H114v4.4H74.5c-5.1,0-4.5,4.7-4.5,4.7v35.1h-5V75.3c0-3.3,1.9-6.3,5-6.9h44V72.8z M114,66.4h-11.4V43.5 C97.7,44.1,88,49.3,83,55.3h16.7v11.2H64h-0.1H13.9v-22h11.2v10.8h19.7C38.5,48,25.1,41.7,13.9,42.1V22.5h27.2v11.2 c0,0-9.1,0-9.1,0c16.3,5.5,28,19.2,31.9,32.6c4.9-15.3,16.9-27.4,32-32.6l-9.2,0V22.5h15.9v-3.2H114V66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.8,66.4H64c0-0.1,0-0.1-0.1-0.2C63.9,66.3,63.9,66.4,63.8,66.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaac);
export default __webpack_public_path__ + "static/media/baac.2e9c08ccee166e0e07c2c8e185c3e9b9.svg";
export { ForwardRef as ReactComponent };